import enUS from './en-US';
import esES from './es-ES';

export const resources = {
  'en-US': enUS,
  'es-ES': esES,
};

export type Language = keyof typeof resources;

export const supportedLanguages = Object.keys(resources) as Language[];

export const defaultLanguage = 'en-US';
